import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import Icon from '../Icon';
import Logo from '../Logo';
import './style.scss';

const Drawer = ({ title, children, backgroundColor = '#1B1A84', LogoComponent }) => {
	const [menuActive, setMenuActive] = useState(false);

	const toggleMenu = () => {
		setMenuActive(!menuActive);
	};

	return (
		<div className={menuActive ? 'drawer-container active' : 'drawer-container'} style={{ backgroundColor: backgroundColor }}>
			<div className="meta">
				<NavLink to="/">
					{LogoComponent? <LogoComponent /> : <Logo className="logo-image" alt="NearSt" color="#fff" />}
				</NavLink>
				<div className="menu-toggle" onClick={() => toggleMenu()}>
					<Icon>menu</Icon>
				</div>
			</div>
			<div className="drawer-links" onClick={() => toggleMenu()}>
				{children}
			</div>

			{title ? <div className="drawer-title">{title}</div> : null}
		</div>
	);
};

Drawer.propTypes = {
	title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
	backgroundColor: PropTypes.string,
	children: PropTypes.node
};

export default Drawer;
